import React from "react";
import moment from "moment";
import { Row, Col } from "reactstrap";
import { useFormik } from "formik";
import { useHistory } from "react-router-dom";

import uploadPdfBtnIcon from "../../assets/images/app/digiPub/upload-pdf-btn-icon.svg";

import { LABLES, NAMES, PLACEHOLDERS } from "./WebFormFieldsNames";
import { companyData, directors, incorporatorData } from "./DummyData";
import TextInput from "../../components/Input/TextInput";
import FormikErrorText from "../../components/FormikErrorText/FormikErrorText";
import validationSchema from "./FormValidations";
import SingleDatePicker from "../../components/Input/SingleDatePicker";
import DirectorDetailsTabs from "./DirectorDetailsTabs";
import { SummaryCard } from "../../components/SummaryCard";
import { CustomButton } from "../../components/CustomButton";
import { APP_ROUTES, getParamsAttachedRoute } from "../../helpers/routeHelpers";

let {
    COMPANY_NAME,
    DATE_OF_INCORPORATION,
    CORPORATION_NUMBER,
    REGISTERED_OFFICE_ADDRESS,
    RECORD_ADDRESS,
    PLACES_OF_BUSINESS_ADDRESS,
    CONTACT_NUMBER,
    FAX,
    EMAIL,
    WEBSITE,
    APPOINTMENT_CALENDER_LINK,
    INCORPORATOR_NAME,
    FIRM_NAME,
    FULL_ADDRESS,
    BAR_STATE
} = LABLES;

const defaultIncorporationDate = companyData.incorporationDate
    ? moment(companyData.incorporationDate, "DD MMM, YYYY").toDate()
    : new Date();

const defaultFormData = {
    [NAMES[COMPANY_NAME]]: companyData.companyName || "",
    [NAMES[DATE_OF_INCORPORATION]]: defaultIncorporationDate,
    [NAMES[CORPORATION_NUMBER]]: companyData.corporationNumber || "",
    [NAMES[REGISTERED_OFFICE_ADDRESS]]: companyData.registeredAddress || "",
    [NAMES[RECORD_ADDRESS]]: companyData.recordAddress || "",
    [NAMES[PLACES_OF_BUSINESS_ADDRESS]]: companyData.businessAddress || "",
    [NAMES[CONTACT_NUMBER]]: incorporatorData.contactNumber || "",
    [NAMES[FAX]]: incorporatorData.fax || "",
    [NAMES[EMAIL]]: incorporatorData.email || "",
    [NAMES[WEBSITE]]: incorporatorData.website || "",
    [NAMES[APPOINTMENT_CALENDER_LINK]]: incorporatorData.calendarLink || "",
    [NAMES[INCORPORATOR_NAME]]: incorporatorData.incorporatorName || "",
    [NAMES[FIRM_NAME]]: incorporatorData.firmName || "",
    [NAMES[FULL_ADDRESS]]: incorporatorData.address || "",
    [NAMES[BAR_STATE]]: incorporatorData.zipCode || ""
};

const CorporateWebForm = () => {
    const history = useHistory();
    const formik = useFormik({
        initialValues: { ...defaultFormData },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values) => {}
    });

    return (
        <>
            <SummaryCard title="Company Details" cardClass="my-4 p-4">
                <div className="border-bottom">
                    <Row className="mt-4">
                        <Col md="4">
                            <TextInput
                                placeholder={PLACEHOLDERS[COMPANY_NAME]}
                                label={COMPANY_NAME}
                                name={NAMES[COMPANY_NAME]}
                                type={NAMES[COMPANY_NAME]}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values[NAMES[COMPANY_NAME]]}
                                labelClass="custom-label mb-0"
                                className="hide-default-icon text-input"
                                autoFocus
                            />

                            <FormikErrorText
                                formikInstance={formik}
                                fieldName={NAMES[COMPANY_NAME]}
                                className="error"
                            />
                        </Col>
                        <Col md="4">
                            <SingleDatePicker
                                labelClass="custom-label mb-0"
                                label={DATE_OF_INCORPORATION}
                                selectedDate={
                                    formik.values[NAMES[DATE_OF_INCORPORATION]] ||
                                    defaultIncorporationDate
                                } // Display the default
                                handleChangeDate={(date) =>
                                    formik.setFieldValue(NAMES[DATE_OF_INCORPORATION], date)
                                }
                                icon="bx bx-calendar"
                            />
                            <FormikErrorText
                                formikInstance={formik}
                                fieldName={NAMES[DATE_OF_INCORPORATION]}
                                className="error"
                            />
                        </Col>
                        <Col md="4">
                            {/* <LabelValuePair label="Corporation Number" value={data.corporationNumber} /> */}
                            <TextInput
                                placeholder={PLACEHOLDERS[CORPORATION_NUMBER]}
                                label={CORPORATION_NUMBER}
                                name={NAMES[CORPORATION_NUMBER]}
                                type={NAMES[CORPORATION_NUMBER]}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values[NAMES[CORPORATION_NUMBER]]}
                                labelClass="custom-label mb-0"
                                className="hide-default-icon text-input"
                                autoFocus
                            />

                            <FormikErrorText
                                formikInstance={formik}
                                fieldName={NAMES[CORPORATION_NUMBER]}
                                className="error"
                            />
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <Col md="4">
                            <TextInput
                                placeholder={PLACEHOLDERS[REGISTERED_OFFICE_ADDRESS]}
                                label={REGISTERED_OFFICE_ADDRESS}
                                name={NAMES[REGISTERED_OFFICE_ADDRESS]}
                                type={NAMES[REGISTERED_OFFICE_ADDRESS]}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values[NAMES[REGISTERED_OFFICE_ADDRESS]]}
                                labelClass="custom-label mb-0"
                                className="hide-default-icon text-input"
                                autoFocus
                            />

                            <FormikErrorText
                                formikInstance={formik}
                                fieldName={NAMES[REGISTERED_OFFICE_ADDRESS]}
                                className="error"
                            />
                        </Col>
                        <Col md="4">
                            <TextInput
                                placeholder={PLACEHOLDERS[RECORD_ADDRESS]}
                                label={RECORD_ADDRESS}
                                name={NAMES[RECORD_ADDRESS]}
                                type={NAMES[RECORD_ADDRESS]}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values[NAMES[RECORD_ADDRESS]]}
                                labelClass="custom-label mb-0"
                                className="hide-default-icon text-input"
                                autoFocus
                            />

                            <FormikErrorText
                                formikInstance={formik}
                                fieldName={NAMES[RECORD_ADDRESS]}
                                className="error"
                            />
                        </Col>

                        <Col md="4">
                            <TextInput
                                placeholder={PLACEHOLDERS[PLACES_OF_BUSINESS_ADDRESS]}
                                label={PLACES_OF_BUSINESS_ADDRESS}
                                name={NAMES[PLACES_OF_BUSINESS_ADDRESS]}
                                type={NAMES[PLACES_OF_BUSINESS_ADDRESS]}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values[NAMES[PLACES_OF_BUSINESS_ADDRESS]]}
                                labelClass="custom-label mb-0"
                                className="hide-default-icon text-input"
                                autoFocus
                            />

                            <FormikErrorText
                                formikInstance={formik}
                                fieldName={NAMES[PLACES_OF_BUSINESS_ADDRESS]}
                                className="error"
                            />
                        </Col>
                    </Row>
                </div>
            </SummaryCard>
            <SummaryCard title="Director Details" cardClass="my-4 p-4">
                <div className="border-bottom">
                    <DirectorDetailsTabs directorsData={directors} />
                </div>
            </SummaryCard>

            <SummaryCard title="Incorporator Details" cardClass="my-4 p-4">
                <div className="border-bottom">
                    <Row className="mt-4">
                        <Col md="4">
                            <TextInput
                                placeholder={PLACEHOLDERS[INCORPORATOR_NAME]}
                                label={INCORPORATOR_NAME}
                                name={NAMES[INCORPORATOR_NAME]}
                                type={NAMES[INCORPORATOR_NAME]}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values[NAMES[INCORPORATOR_NAME]]}
                                labelClass="custom-label mb-0"
                                className="hide-default-icon text-input"
                                autoFocus
                            />

                            <FormikErrorText
                                formikInstance={formik}
                                fieldName={NAMES[INCORPORATOR_NAME]}
                                className="error"
                            />
                        </Col>
                        <Col md="4">
                            <TextInput
                                placeholder={PLACEHOLDERS[FIRM_NAME]}
                                label={FIRM_NAME}
                                name={NAMES[FIRM_NAME]}
                                type={NAMES[FIRM_NAME]}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values[NAMES[FIRM_NAME]]}
                                labelClass="custom-label mb-0"
                                className="hide-default-icon text-input"
                                autoFocus
                            />

                            <FormikErrorText
                                formikInstance={formik}
                                fieldName={NAMES[FIRM_NAME]}
                                className="error"
                            />
                        </Col>
                        <Col md="4">
                            <TextInput
                                placeholder={PLACEHOLDERS[FULL_ADDRESS]}
                                label={FULL_ADDRESS}
                                name={NAMES[FULL_ADDRESS]}
                                type={NAMES[FULL_ADDRESS]}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values[NAMES[FULL_ADDRESS]]}
                                labelClass="custom-label mb-0"
                                className="hide-default-icon text-input"
                                autoFocus
                            />

                            <FormikErrorText
                                formikInstance={formik}
                                fieldName={NAMES[FULL_ADDRESS]}
                                className="error"
                            />
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <Col md="4">
                            <TextInput
                                placeholder={PLACEHOLDERS[BAR_STATE]}
                                label={BAR_STATE}
                                name={NAMES[BAR_STATE]}
                                type={NAMES[BAR_STATE]}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values[NAMES[BAR_STATE]]}
                                labelClass="custom-label mb-0"
                                className="hide-default-icon text-input"
                                autoFocus
                            />

                            <FormikErrorText
                                formikInstance={formik}
                                fieldName={NAMES[BAR_STATE]}
                                className="error"
                            />
                        </Col>
                        <Col md="4">
                            <SingleDatePicker
                                labelClass="custom-label mb-0"
                                label={DATE_OF_INCORPORATION}
                                selectedDate={
                                    formik.values[NAMES[DATE_OF_INCORPORATION]] ||
                                    defaultIncorporationDate
                                } // Display the default
                                handleChangeDate={(date) =>
                                    formik.setFieldValue(NAMES[DATE_OF_INCORPORATION], date)
                                }
                                icon="bx bx-calendar"
                            />
                            <FormikErrorText
                                formikInstance={formik}
                                fieldName={NAMES[DATE_OF_INCORPORATION]}
                                className="error"
                            />
                        </Col>
                        <Col md="4">
                            <TextInput
                                placeholder={PLACEHOLDERS[CONTACT_NUMBER]}
                                label={CONTACT_NUMBER}
                                name={NAMES[CONTACT_NUMBER]}
                                type={NAMES[CONTACT_NUMBER]}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values[NAMES[CONTACT_NUMBER]]}
                                labelClass="custom-label mb-0"
                                className="hide-default-icon text-input"
                                autoFocus
                            />

                            <FormikErrorText
                                formikInstance={formik}
                                fieldName={NAMES[CONTACT_NUMBER]}
                                className="error"
                            />
                        </Col>
                    </Row>

                    <Row className="mt-4">
                        <Col md="4">
                            <TextInput
                                placeholder={PLACEHOLDERS[FAX]}
                                label={FAX}
                                name={NAMES[FAX]}
                                type={NAMES[FAX]}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values[NAMES[FAX]]}
                                labelClass="custom-label mb-0"
                                className="hide-default-icon text-input"
                                autoFocus
                            />

                            <FormikErrorText
                                formikInstance={formik}
                                fieldName={NAMES[FAX]}
                                className="error"
                            />
                        </Col>
                        <Col md="4">
                            <TextInput
                                placeholder={PLACEHOLDERS[EMAIL]}
                                label={EMAIL}
                                name={NAMES[EMAIL]}
                                type={NAMES[EMAIL]}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values[NAMES[EMAIL]]}
                                labelClass="custom-label mb-0"
                                className="hide-default-icon text-input"
                                autoFocus
                            />

                            <FormikErrorText
                                formikInstance={formik}
                                fieldName={NAMES[EMAIL]}
                                className="error"
                            />
                        </Col>
                        <Col md="4">
                            <TextInput
                                placeholder={PLACEHOLDERS[WEBSITE]}
                                label={WEBSITE}
                                name={NAMES[WEBSITE]}
                                type={NAMES[WEBSITE]}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values[NAMES[WEBSITE]]}
                                labelClass="custom-label mb-0"
                                className="hide-default-icon text-input"
                                autoFocus
                            />

                            <FormikErrorText
                                formikInstance={formik}
                                fieldName={NAMES[WEBSITE]}
                                className="error"
                            />
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <Col md="4">
                            <TextInput
                                placeholder={PLACEHOLDERS[APPOINTMENT_CALENDER_LINK]}
                                label={APPOINTMENT_CALENDER_LINK}
                                name={NAMES[APPOINTMENT_CALENDER_LINK]}
                                type={NAMES[APPOINTMENT_CALENDER_LINK]}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values[NAMES[APPOINTMENT_CALENDER_LINK]]}
                                labelClass="custom-label mb-0"
                                className="hide-default-icon text-input"
                                autoFocus
                            />

                            <FormikErrorText
                                formikInstance={formik}
                                fieldName={NAMES[APPOINTMENT_CALENDER_LINK]}
                                className="error"
                            />
                        </Col>
                    </Row>
                </div>
                <Row className="d-flex justify-content-start">
                    <Col sm="12" md="12" lg="12" className="d-flex justify-content-start mt-4">
                        <CustomButton
                            loading={false}
                            type={"submit"}
                            title="Generate Pdf"
                            color="primary"
                            className="custom-btn-md  mt-2 grad-primary"
                            img={uploadPdfBtnIcon}
                            onClick={() =>
                                history.push(getParamsAttachedRoute(APP_ROUTES.PDF_LISTING))
                            }
                        />
                    </Col>
                </Row>
            </SummaryCard>
        </>
    );
};

export default CorporateWebForm;
